import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import { Warning, CheckCircle, Cancel } from "@mui/icons-material";

const UnattemptedQuestionsDialog = ({
  open,
  onClose,
  onContinue,
  unattemptedCount = 0,
  hasTimeRemaining = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={undefined} // Disable click-outside-to-close
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={true} // Disable ESC key to close
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center", pt: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Warning color="warning" sx={{ fontSize: 50 }} />
          <Typography variant="h6" fontWeight="bold">
            Unattempted Questions – Confirm Section Completion
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        {hasTimeRemaining && (
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2">
              You still have time remaining.
            </Typography>
          </Alert>
        )}

        <Typography variant="body1" paragraph>
          {unattemptedCount > 0
            ? `You have ${unattemptedCount} unattempted question${
                unattemptedCount > 1 ? "s" : ""
              }.`
            : "Some questions have not been attempted."}
        </Typography>

        <Typography variant="body1" paragraph>
          If you choose to finish this section now, you will not be able to
          return to complete the unanswered questions.
        </Typography>

        <Typography variant="body1" fontWeight="bold">
          Are you sure you want to finish this section?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 2, justifyContent: "center" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          startIcon={<Cancel />}
          sx={{ minWidth: 180 }}
        >
          No, go back to complete the section
        </Button>
        <Button
          onClick={onContinue}
          variant="contained"
          color="warning"
          startIcon={<CheckCircle />}
          sx={{ minWidth: 180 }}
        >
          Yes, finish this section
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnattemptedQuestionsDialog;
